import { apiRequest } from "../client/apiClient";
import { retryRequest } from "../helpers/retryRequest";

export async function fetchFeatureGroups(searchString) {
  return retryRequest(() =>
    apiRequest(`/featuregroups${searchString ? `?${searchString}` : ``}`),
  );
}

export async function saveFeatureGroup(featureGroup) {
  return retryRequest(() =>
    apiRequest("/featuregroup/add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(featureGroup),
    }),
  );
}

export async function editFeatureGroup(featureGroup) {
  return retryRequest(() =>
    apiRequest(`/featuregroup/edit/${featureGroup.featureGroupCode}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(featureGroup),
    }),
  );
}

export async function deleteFeatureGroup(featureGroup) {
  return retryRequest(() =>
    apiRequest(`/featuregroup/delete/${featureGroup.featureGroupCode}`, {
      method: "delete",
      headers: { "Content-Type": "application/json" },
    }),
  );
}
